import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LogIn, LayoutDashboard } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";

export function HelpLayout({ children }: { children: ReactNode }) {
  const { t, i18n } = useTranslation();
  const { user } = useAuth();

  function toggleLang() {
    const next = i18n.language.startsWith("es") ? "en" : "es";
    i18n.changeLanguage(next);
  }

  return (
    <div className="min-h-screen flex flex-col bg-sand">
      <header className="relative overflow-hidden bg-hero-gradient text-white">
        <div className="absolute inset-0 bg-ocean-mist opacity-60" aria-hidden="true" />
        <nav className="relative max-w-6xl mx-auto px-6 py-5 flex items-center justify-between z-10">
          <Link to={user ? "/dashboard" : "/"} className="flex items-center gap-3 hover:opacity-90">
            <Logo variant="icon" color="white" className="h-11" />
            <div className="leading-tight">
              <div className="font-serif text-lg tracking-wider">COSTA DORADA I</div>
              <div className="text-xs text-primary-100 tracking-widest uppercase">{t("nav.help")}</div>
            </div>
          </Link>
          <div className="flex items-center gap-4">
            <button
              onClick={toggleLang}
              className="text-sm hover:text-dorado-200 transition uppercase tracking-wider"
              title={t("common.language")}
            >
              {i18n.language.startsWith("es") ? "English" : "Español"}
            </button>
            {user ? (
              <Link
                to="/dashboard"
                className="btn bg-white/95 text-primary-700 hover:bg-white font-medium tracking-wide shadow-lg text-sm"
              >
                <LayoutDashboard size={14} />
                {t("nav.dashboard")}
              </Link>
            ) : (
              <Link
                to="/login"
                className="btn bg-white/95 text-primary-700 hover:bg-white font-medium tracking-wide shadow-lg text-sm"
              >
                <LogIn size={14} />
                {t("auth.login")}
              </Link>
            )}
          </div>
        </nav>
      </header>
      <main className="flex-1 max-w-6xl mx-auto w-full px-6 py-10">{children}</main>
      <footer className="text-center text-xs text-primary-200 py-5 bg-primary-800 border-t border-primary-700/50">
        © {new Date().getFullYear()} Condominio Costa Dorada I — Puerto Rico
      </footer>
    </div>
  );
}
